import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { LoginPage } from './login.page';
import { TermsPage } from './terms/terms.page';
import { BeforeLoginNotificationsPage } from './before-login-notifications/before-login-notifications.page';
import { AfterLoginNotificationsPage } from './after-login-notifications/after-login-notifications.page';

const routes: Routes = [
  {
    path: '',
    component: LoginPage
  },
  {
    path: 'notifications',
    component: BeforeLoginNotificationsPage
  },
  {
    path: 'after-notifications',
    component: AfterLoginNotificationsPage
  },
  {
    path: 'terms',
    component: TermsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class LoginPageRoutingModule {}
